import { get,postP } from '@/utils/axios'

export default {
    
    // 管理登录
    signIn(datas){
        return get('OAuth/SignInAsync',datas)
    }
}